import { render, staticRenderFns } from "./MainWorksSectionHeader.vue?vue&type=template&id=3dd49a9a&scoped=true&"
import script from "./MainWorksSectionHeader.vue?vue&type=script&lang=js&"
export * from "./MainWorksSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainWorksSectionHeader.vue?vue&type=style&index=0&id=3dd49a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd49a9a",
  null
  
)

export default component.exports